import { format } from "date-fns";

export function agruparRetorno<T extends { data: Date | string }>(documentos: T[]) {
  return documentos.reduce((acc: Record<string, T[]>, documento) => {
    const dataKey = format(new Date(documento.data), 'yyyy-MM-dd');
    if (!acc[dataKey]) {
      acc[dataKey] = [];
    }
    acc[dataKey].push(documento);
    return acc;
  }, {});
}